import { render, staticRenderFns } from "./PasswordRules.vue?vue&type=template&id=9768cd5c&scoped=true&"
var script = {}
import style0 from "./PasswordRules.vue?vue&type=style&index=0&id=9768cd5c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9768cd5c",
  null
  
)

export default component.exports